import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { PROJECT_API } from "./apiRoutes";

interface UseGetDependenciesByProjectIdProps {
  projectId: string;
  planId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getDependenciesByProjectId = async (projectId: string, planId: string) => {
  return await axiosAuth.get(`${PROJECT_API}/${projectId}/plans/${planId}/dependencies`);
};

const useGetDependenciesByProjectId = ({
  projectId,
  planId,
  queryParams
}: UseGetDependenciesByProjectIdProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["dependency-list", projectId, planId],
    queryFn: () => getDependenciesByProjectId(projectId, planId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetDependenciesByProjectId;
